import { combineReducers, createReducer } from '@reduxjs/toolkit';

import {
  clearHistoryAction,
  clearQueriesHistoryAction,
  setCompared,
  setQueriesHistoryAction,
} from 'Core/actions/localStorage';
import { fromPayload } from 'Core/reducers/common';
import { SearchItemDataCollection } from 'Models/index';
import { loadCompared, loadProductsHistory, loadQueriesHistory } from 'Utils/userStorage';

const initStates = {
  compared: new SearchItemDataCollection(loadCompared(), 'compared'),
  productsHistory: loadProductsHistory(),
  queriesHistory: loadQueriesHistory(),
};

export default combineReducers({
  compared: createReducer(initStates.compared, (builder) => builder.addCase(setCompared, fromPayload)),
  productsHistory: createReducer(initStates.productsHistory, (builder) =>
    builder.addCase(clearHistoryAction, () => []),
  ),
  queriesHistory: createReducer(initStates.queriesHistory, (builder) =>
    builder
      .addCase(setQueriesHistoryAction, fromPayload)
      .addCase(clearQueriesHistoryAction, () => [])
      .addCase(clearHistoryAction, () => []),
  ),
});
